/** Portfolio opportunity funnel: headline savings + top customers by opportunity. */
import { formatUsd } from "@/types/booking";
import type { InsightPayload } from "@/types/feed";

import { customerBookingsHref, opportunityBookingsHref } from "../../feedLinks";
import { compareScale, plural } from "../formatInsight";
import { explainerFor } from "../insightCopy";
import { ChangeRow, CtaLink, EntitySection, InsightShell, MetricGrid } from "../primitives";

export function PortfolioFunnelView({ payload }: { payload: InsightPayload }) {
  const m = payload.metrics;
  const customers = payload.top_customers ?? [];
  const savingsMax = compareScale(customers.map((c) => c.unrealized_savings_usd));
  return (
    <InsightShell explainer={explainerFor(payload as unknown as Record<string, unknown>)}>
      {m && (
        <MetricGrid
          items={[
            { label: "Unrealized savings", value: formatUsd(m.unrealized_savings_usd) },
            { label: "Opportunities", value: String(m.opportunities_detected) },
            { label: "Actionable", value: String(m.actionable_count) },
            { label: "Acted upon", value: String(m.acted_upon_count) },
          ]}
        />
      )}
      {customers.length > 0 && (
        <EntitySection title="Top customers">
          {customers.map((c) => (
            <ChangeRow
              key={c.consignee}
              name={c.consignee}
              href={customerBookingsHref(c.consignee)}
              party
              primary={formatUsd(c.unrealized_savings_usd)}
              subtitle={plural(c.opportunity_count, "opportunity")}
              bar={{ type: "share", value: c.unrealized_savings_usd, max: savingsMax }}
            />
          ))}
        </EntitySection>
      )}
      <CtaLink to={opportunityBookingsHref()}>View opportunities</CtaLink>
    </InsightShell>
  );
}
